import guestlistDuplicationSettingsTemplate
    from '../../../../modules/guestlists/views/modals/guestlist-duplication-settings-modal-controller.tpl.html';
import GuestlistDuplicationSettingsModalController
    from '../../../../modules/guestlists/controllers/modals/guestlist-duplication-settings-modal-controller';

class DuplicateMultipleGuestlistsWorkflow {

    constructor($injector) {
        this.injector = $injector;
        this.alert = this.injector.get('Alert');
        this.api = this.injector.get('$http');
        this.modal = this.injector.get('$uibModal');
        this.userStore = this.injector.get('Users');


        this.key = 'duplicate-guestlists';
        this.title = 'Copy guestlists';
        this.icon = 'copy';
        this.level = 'selected';
    }

    async action(payload, store) {
        let duplicateSettings = null;
        try {
            duplicateSettings = await this.modal
                .open({
                    templateUrl: guestlistDuplicationSettingsTemplate,
                    controller: GuestlistDuplicationSettingsModalController,
                    controllerAs: 'vm',
                    resolve: {
                        showGuestlistParams: () => {
                            return false;
                        },
                        oldGuestlist: () => {
                            return null
                        }
                    }
                })
                .result;
        } catch (e) {
            console.log(e);
        }

        if (!duplicateSettings) {
            return;
        }

        try {
            this.api
                .post('guestlists/duplicate', {
                    ...duplicateSettings,
                    guestlists: store.getters.selectedFilters
                })
                .then(() => {
                    store.dispatch('getData');
                });
        } catch (e) {
            this.alert.error('Error', 'Error while starting duplication. Please try again');
        }

        this.alert.success('Duplication started', 'Event duplication was started.');
    }
}


angular
    .module('festzelt-os.guestlists')
    .factory('duplicateGuestlists', [
        '$injector',
        $injector => new DuplicateMultipleGuestlistsWorkflow($injector)
    ]);





// WEBPACK FOOTER //
// ./src/app/pages/guestlists/workflows/general/duplicate-guestlists.js